import "flowbite";
import AdminPrifile from "./AdminProfile";
import { ToastContainer, toast } from "react-toastify";
import { AiFillEdit } from "react-icons/ai";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading";

import { ethers } from "ethers";
import { useEffect, useState } from "react";

const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

//cutom Signer
const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);


// end Custom Signer
const Users = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const [fiatUsers, setFiatUsers] = useState("0");
  const [cryptoUsers, setCryptoUsers] = useState("0");
  const [totalUsers, setTotalUsers] = useState("0");
  const [visitors, setVisitors] = useState("0");
  const [createrUser, setCreaterUser] = useState("0");

  const [isLoading, setIsLoading] = useState(false);

  const getUserHistory = async () => {
    setIsLoading(true);
    try {
      await axios
        .get(`${process.env.REACT_APP_SERVER_URL}/user-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          
          // console.log("get User History: ", res);
          setFiatUsers(res.data.data.fiatUser);
          setCryptoUsers(res.data.data.cryptoUser);
          setTotalUsers(res.data.data.totalUser);
          setVisitors(res.data.data.visterUser);
          setCreaterUser(res.data.data.createrUser);
          setIsLoading(false)

          // console.log(res)
        });
    } catch
       (error) {
        setIsLoading(false)
        console.error("Error logging in:", error);
        localStorage.setItem("reload", true);
        navigate("/#");
      
    }
  };

  useEffect(() => {
    getUserHistory();
  }, []);

  return (
    <div style={{ opacity: 1 }} className="relative z-50">
      <div className="antialiased bg-[#212445]  w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <AdminPrifile />

          <div
            id="usersInfo"
            className="bg-[#151c2c] col-span-9 rounded-lg p-6 my-10 relative z-30"
          >
            <div>
              <h1 className="font-bold py-4 uppercase">Users</h1>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 md:px-28 px-4 py-10 justify-around">
                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">Total Users</div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {totalUsers}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Fiat Users
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {fiatUsers}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Crypto Users
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {cryptoUsers}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Visitors
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">{visitors}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#23314c] rounded-lg hover:cursor-pointer w-full">
                  <div className="text-sm font-bold pt-4 px-4">
                    Total Creators
                  </div>
                  <div className="flex flex-row items-center">
                    <div className="p-4">
                      <div className="cursor-pointer mx-auto">
                        <p className="text-lg my-auto">
                          <span className="text-4xl font-bold">
                            {createrUser}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        onClick={() => {
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>
      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default Users;
